export default __webpack_public_path__ + "static/media/angular-icon.07879125.svg";